import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import ForgotPassword from "../components/Login/ForgotPassword";
import { ClientContextProvider } from "../components/SuperAdmin/ManageClient/HandleAddClientContext";

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));


  // Super Admin components ---------------
  const DashboardSA = React.lazy(() => import("../components/SuperAdmin/Dashboard/DashboardSA"));
  const ManageClient = React.lazy(() => import("../components/SuperAdmin/ManageClient/ManageClient"));
  const AddClient = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/BusinessBasicDetails"));
  const BusinessDocuments = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/BusinessDocuments"));
  const BankDetails = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/BankDetails"));
  const BranchDetails = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/OutletDetails"));
  const SubscriptionPlans = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/SubscriptionPlans"));
  const ContractsAndLegal = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/ContractsAndLegal"));
  const ClientDetails = React.lazy(() => import("../components/SuperAdmin/ManageClient/ClientDetails"));
  const ManageSupport = React.lazy(() => import("../components/SuperAdmin/ManageSupport/ManageSupport"));
  const ViewIssueDetails = React.lazy(() => import("../components/SuperAdmin/ManageSupport/ViewIssueDetails"));
  const ManageSubscription = React.lazy(() => import("../components/SuperAdmin/ManageSubscription/ManageSubscription"));
  const CreateSubscription = React.lazy(() => import("../components/SuperAdmin/ManageSubscription/Create&EditSubscriptionPlans"));
  const ManageRole = React.lazy(() => import("../components/SuperAdmin/ManageNewRoleDesign/RBAC"));
  const CreateRole = React.lazy(() => import("../components/SuperAdmin/ManageRole/CreateRole"));
  const EditRole = React.lazy(() => import("../components/SuperAdmin/ManageNewRoleDesign/EditRole"));
  const Settings = React.lazy(() => import("../components/SuperAdmin/Settings/ManageSettings"));
  const ManageAdminUser = React.lazy(() => import("../components/SuperAdmin/ManageAdminUser/ManageAdminUser"));
  const CreateAdminUser = React.lazy(() => import("../components/SuperAdmin/ManageAdminUser/CreateAdminUser"));
  const EditOuletDetail = React.lazy(() => import("../components/SuperAdmin/ManageClient/AddClient/EditOutletDetails"));
  const Profile = React.lazy(() => import("../components/Profile"));
  const HandlePaymentScreen = React.lazy(() => import("../components/SuperAdmin/Payment/HandlePayment"));
  const ManageCMS = React.lazy(() => import("../components/SuperAdmin/CMS/ManageCms"));
  const EditCMS = React.lazy(() => import("../components/SuperAdmin/CMS/EditCms"));

  const DefaultRBAC = React.lazy(() => import("../components/SuperAdmin/ManageDefaultRBAC/RBAC"));
  const AddDefaultRole = React.lazy(() => import("../components/SuperAdmin/ManageDefaultRBAC/CreateRole"));

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <Suspense fallback={<></>}>
                <ForgotPassword />
              </Suspense>
            }
          />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >

            {/* Super Admin Routs  */}
            <Route path="/dashboard" element={<Suspense fallback={<></>}> <DashboardSA /> </Suspense>} />
            <Route path="/profile" element={<Suspense fallback={<></>}> <Profile /> </Suspense>} />
            <Route path="/manage-clients" element={<Suspense fallback={<></>}> <ManageClient /> </Suspense>} />
            <Route path="/add-client/business-basic-details/:type/:uuid" element={<Suspense fallback={<></>}> <ClientContextProvider><AddClient /></ClientContextProvider>  </Suspense>} />
            <Route path="/add-client/business-basic-details/:type" element={<Suspense fallback={<></>}> <AddClient /> </Suspense>} />
            <Route path="/add-client/business-documents/:type/:uuid" element={<Suspense fallback={<></>}> <BusinessDocuments /> </Suspense>} />
            <Route path="/add-client/bank-details/:type/:uuid" element={<Suspense fallback={<></>}> <BankDetails /> </Suspense>} />
            <Route path="/add-client/branch-details/:type/:uuid" element={<Suspense fallback={<></>}> <BranchDetails /> </Suspense>} />
            <Route path="/edit-client/branch-details/:type/:uuid" element={<Suspense fallback={<></>}> <EditOuletDetail /> </Suspense>} />
            <Route path="/add-client/subscription-plans/:type/:uuid" element={<Suspense fallback={<></>}> <SubscriptionPlans /> </Suspense>} />
            <Route path="/add-client/contracts-and-legal/:type/:uuid" element={<Suspense fallback={<></>}> <ContractsAndLegal /> </Suspense>} />
            <Route path="/manage-clients/client-details/:tab/:uuid" element={<Suspense fallback={<></>}> <ClientDetails /> </Suspense>} />
            <Route path="/manage-supports" element={<Suspense fallback={<></>}> <ManageSupport /> </Suspense>} />
            <Route path="/manage-support/view-issue-details/:id" element={<Suspense fallback={<></>}> <ViewIssueDetails /> </Suspense>} />
            <Route path="/manage-subscription" element={<Suspense fallback={<></>}> <ManageSubscription /> </Suspense>} />
            <Route path="/create-subscription" element={<Suspense fallback={<></>}> <CreateSubscription /> </Suspense>} />
            <Route path="/edit-subscription/:id" element={<Suspense fallback={<></>}> <CreateSubscription /> </Suspense>} />
            <Route path="/read-subscription/:id" element={<Suspense fallback={<></>}> <CreateSubscription /> </Suspense>} />
            <Route path="/settings" element={<Suspense fallback={<></>}> <Settings /> </Suspense>} />
            <Route path="/manage-roles" element={<Suspense fallback={<></>}> <ManageRole /> </Suspense>} />
            <Route path="/add-role" element={<Suspense fallback={<></>}> <CreateRole /> </Suspense>} />
            <Route path="/edit-role/:id" element={<Suspense fallback={<></>}> <CreateRole /> </Suspense>} />
            <Route path="/manage-admin-users" element={<Suspense fallback={<></>}> <ManageAdminUser /> </Suspense>} />
            <Route path="/add-admin-user" element={<Suspense fallback={<></>}> <CreateAdminUser /> </Suspense>} />
            <Route path="/edit-admin-user/:id" element={<Suspense fallback={<></>}> <CreateAdminUser /> </Suspense>} />
            <Route path="/payment-handle/:status/:type/:documentstatus" element={<Suspense fallback={<></>}> <HandlePaymentScreen /> </Suspense>} />
            <Route path="/manage-cms" element={<Suspense fallback={<></>}> <ManageCMS /> </Suspense>} />
            <Route path="/manage-cms/:id" element={<Suspense fallback={<></>}> <EditCMS /> </Suspense>} />
            <Route path="/default-client-rbac" element={<Suspense fallback={<></>}> <DefaultRBAC /> </Suspense>} />
            <Route path="/add-default-client-role" element={<Suspense fallback={<></>}> <AddDefaultRole /> </Suspense>} />
          </Route>


        </Routes >
      </div >
    </>
  );
};

export default Navigation;
